var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33325 4.16667C8.33325 3.72464 8.50885 3.30072 8.82141 2.98816C9.13397 2.67559 9.55789 2.5 9.99992 2.5C10.4419 2.5 10.8659 2.67559 11.1784 2.98816C11.491 3.30072 11.6666 3.72464 11.6666 4.16667C12.6236 4.61919 13.4394 5.32361 14.0266 6.20442C14.6138 7.08523 14.9503 8.10923 14.9999 9.16667V11.6667C15.0626 12.1848 15.2461 12.6809 15.5356 13.1151C15.8251 13.5493 16.2125 13.9095 16.6666 14.1667H3.33325C3.78737 13.9095 4.17476 13.5493 4.46424 13.1151C4.75372 12.6809 4.93721 12.1848 4.99992 11.6667V9.16667C5.04955 8.10923 5.386 7.08523 5.97321 6.20442C6.56042 5.32361 7.37624 4.61919 8.33325 4.16667",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 14.1665V14.9998C7.5 15.6629 7.76339 16.2988 8.23223 16.7676C8.70107 17.2364 9.33696 17.4998 10 17.4998C10.663 17.4998 11.2989 17.2364 11.7678 16.7676C12.2366 16.2988 12.5 15.6629 12.5 14.9998V14.1665",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgNotificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.79cea36357808160ee7fe5465f0ea740.svg";
export { ForwardRef as ReactComponent };